// The app writes an author's aiGuidelines as either a single string or an array
// of strings (ThePath/types/Author.ts and ThePath/types/Community.ts, which are
// authoritative for what the value MEANS). Every admin reader wants one string,
// so normalize at the read instead of assuming the narrow shape.
//
// Array entries are separate guideline paragraphs, so they join on a blank line.
// Empty and whitespace-only entries drop out, and the result is trimmed, so a
// caller can keep treating "" as "no guidelines".
export const normalizeAiGuidelines = (
  value: string | string[] | undefined | null
): string => {
  if (Array.isArray(value)) {
    return value
      .map((entry) => String(entry ?? "").trim())
      .filter(Boolean)
      .join("\n\n");
  }
  return String(value ?? "").trim();
};

export default normalizeAiGuidelines;
